<template>
  <div class="card card-desafio" style="cursor: pointer; height:fit-content">
    <div>
      <h5 v-if="userLogged.profile == 'ADMINISTRADOR'">{{challenge.usuario}}</h5>

      <router-link
        :to="'/Desafio/'+challenge.id_challenge+'/'+challenge.usuario"
        style="cursor:pointer"
      >
        <vue-load-image>
          <img class="card-desafio-image" slot="image" :src="challenge.url_contenido" />
          <img class="card-desafio-image" slot="preloader" src="public/images/site/loading.gif" />
          <div slot="error">No encontramos la imagen :-(</div>
        </vue-load-image>
      </router-link>

      <div v-if="userLogged.profile == 'ADMINISTRADOR'">
        <div v-if="pendiente">
          <b-button class="mt-3" variant="success" block @click="aprobar()">Aprobar</b-button>
          <b-button class="mt-2" variant="danger" block @click="rechazar()">Rechazar</b-button>
        </div>
        <div v-if="!pendiente && aprobado" style="text-align:center; padding:10px">
          <h5>Aprobado</h5>
        </div>
        <div v-if="!pendiente && rechazado" style="text-align:center; padding:10px">
          <h5 style="color: darkred">Rechazado</h5>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import VueLoadImage from "vue-load-image";

export default {
  props: ["challenge"],
  data() {
    return {
      eliminaCategoria: "",
      errorMessage: "",
      pendiente: true,
      aprobado: false,
      rechazado: false
    };
  },
  computed: {
    ...mapGetters([
      "categorias",
      "userLogged",
      "pathAPI",
      "challengeSeleccionado"
    ])
  },
  components: {
    "vue-load-image": VueLoadImage
  },
  methods: {
    verChallenge(challenge) {
      sessionStorage.usuarioChallenge = challenge.usuario;
      sessionStorage.idChallenge = challenge.id_challenge;
      sessionStorage.cursoChallenge = challenge.id_curso;
      this.$store.state.challengeSeleccionado = challenge;
      this.$router.push({ path: "/Desafio" });
    },
    aprobar() {
      var bodyApi;
      (bodyApi =
        "usuario=" +
        this.userLogged.user +
        "&id_challenge=" +
        this.challenge.id_challenge +
        "&usuario_challenge=" +
        this.challenge.usuario +
        "&ind_aprobado=S"),
        fetch(this.pathAPI + "challenge_alumno.php?" + bodyApi, {
          method: "PUT",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          })
        })
          .then(response => response.json())
          .then(data => {
            this.pendiente = false;
            this.aprobado = true;
          })
          .catch(() => {
            console.log("error");
          });
    },
    rechazar() {
      var bodyApi;
      (bodyApi =
        "usuario=" +
        this.userLogged.user +
        "&id_challenge=" +
        this.challenge.id_challenge +
        "&usuario_challenge=" +
        this.challenge.usuario +
        "&ind_aprobado=R"),
        fetch(this.pathAPI + "challenge_alumno.php?" + bodyApi, {
          method: "PUT",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          })
        })
          .then(response => response.json())
          .then(data => {
            this.pendiente = false;
            this.rechazado = true;
          })
          .catch(() => {
            console.log("error");
          });
    }
  }
};
</script>

<style scoped>
.card-desafio {
  border-radius: 15px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  margin: 10px;
  width: 150px;
}

.card-desafio:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

.card-desafio-image {
  border-radius: 10px;
  width: 150px;
}
@media screen and (max-width: 600px) {
  .card-desafio {
    width: 100px;
    margin: 10px;
  }
  .card-desafio-image {
    border-radius: 10px;
    width: 100px;
  }
}


</style>


// WEBPACK FOOTER //
// src/components/challenges/Challenge.vue